import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { Navbar } from "./components/medical/Navbar";
import { Hero } from "./components/medical/Hero";
import { HowWeDoIt } from "./components/medical/HowWeDoIt";
import { Specialities } from "./components/medical/Specialities";
import { Doctors } from "./components/medical/Doctors";
import { Hospitals } from "./components/medical/Hospitals";
import { Testimonials } from "./components/medical/Testimonials";
import { EnquiryForm } from "./components/medical/EnquiryForm";
import { WhatsappFloat } from "./components/medical/WhatsappFloat";
import { Footer } from "./components/medical/Footer";
import { SEO } from "./components/medical/SEO";
import { DoctorProfile } from "./pages/DoctorProfile";
import { SpecialtyPage } from "./pages/SpecialtyPage";
import { TreatmentPage } from "./pages/TreatmentPage";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminDashboard } from "./pages/AdminDashboard";

const Landing = () => {
    return (
        <div className="min-h-screen bg-background font-body">
            <SEO />
            <Navbar />
            <main>
                <Hero />
                <HowWeDoIt />
                <Specialities />
                <Doctors />
                <Hospitals />
                <Testimonials />
                <EnquiryForm />
            </main>
            <Footer />
            <WhatsappFloat />
        </div>
    );
};

function App() {
    return (
        <HelmetProvider>
            <AuthProvider>
                <div className="App">
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/doctors/:slug" element={<DoctorProfile />} />
                            <Route path="/specialties/:slug" element={<SpecialtyPage />} />
                            <Route path="/treatments/:slug" element={<TreatmentPage />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminDashboard />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster position="top-center" richColors />
                </div>
            </AuthProvider>
        </HelmetProvider>
    );
}

export default App;
